/**
 * @description Channel Partner admin. layout (LYN-309)
 *
 * @dependencies BaseSidebarLayout, ChannelPartnerSidebar
 * @notes Host is admin.{slug}.staging.lynx.build (or localhost). Not app.
 */

import BaseSidebarLayout from '../shared/BaseSidebarLayout';
import ChannelPartnerSidebar from './ChannelPartnerSidebar';

const ChannelPartnerLayout = () => {
  return (
    <BaseSidebarLayout
      SidebarContent={ChannelPartnerSidebar}
      storageKey="cpSidebarOpen"
    />
  );
};

export default ChannelPartnerLayout;
